import { Sound } from '../types/Sound'

// Category definitions with metadata
export const categoryDefinitions: Record<string, { name: string; displayName: string; icon: string }> = {
  drums: {
    name: 'drums',
    displayName: 'Drums & Percussion',
    icon: '🥁'
  },
  instruments: {
    name: 'instruments',
    displayName: 'Musical Instruments',
    icon: '🎵'
  },
  effects: {
    name: 'effects',
    displayName: 'Sound Effects',
    icon: '✨'
  },
  nature: {
    name: 'nature',
    displayName: 'Nature Sounds',
    icon: '🌿'
  },
  custom: {
    name: 'custom',
    displayName: 'My Recordings',
    icon: '🎤'
  }
}

// Group sounds by category
export const soundsByCategory = (sounds: Sound[]): Record<string, Sound[]> => {
  return sounds.reduce((acc, sound) => {
    if (!acc[sound.category]) {
      acc[sound.category] = []
    }
    acc[sound.category].push(sound)
    return acc
  }, {} as Record<string, Sound[]>)
}

// Get category statistics
export const getCategoryStats = (sounds: Sound[] = []) => {
  const categoryMap = soundsByCategory(sounds)

  return Object.entries(categoryMap).map(([category, categorySounds]) => {
    const definition = categoryDefinitions[category] || {
      name: category,
      displayName: category,
      icon: '🎵'
    }

    return {
      name: definition.name,
      displayName: definition.displayName,
      icon: definition.icon,
      count: categorySounds.length
    }
  }).sort((a, b) => a.name.localeCompare(b.name))
}

// Get sounds by category
export const getSoundsByCategory = (sounds: Sound[], categoryName: string): Sound[] => {
  return sounds.filter(sound => sound.category === categoryName)
}

// Get all unique categories from sounds
export const getAllCategories = (sounds: Sound[]): string[] => {
  const categories = new Set(sounds.map(sound => sound.category))
  return Array.from(categories).sort()
}